import { makeStyles } from "tss-react/mui";
import { Grid, Typography, Box, Stack, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useStation } from "../../../../providers/StationProvider";
import { Check as CheckIcon, InfoOutlined as InfoIcon } from "@mui/icons-material";
import NetworkProfileDialog from "./NetworkProfileDialog";
import { Task } from "@emberly/zenith-client";
import { useDevice } from "../../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      padding: theme.spacing(3),
      borderRadius: theme.spacing(2),
      background: theme.palette.background.default,
      width: "100%"
    },
    rootSlim: {
      width: "100%",
      "& button": {
        padding: theme.spacing(3.5)
      }
    },
    appIcon: {
      width: "56px",
      height: "auto",
      borderRadius: theme.spacing(1)
    },
    link: {
      color: theme.palette.text.secondary
    },
    actions: {
      paddingTop: theme.spacing(2),
      width: "100%"
    }
  })
);

export default function JoinNowCard(props) {
  const { onJoined } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();

  const { updateStation } = useStation();
  const [joinTask, setJoinTask] = useState(null);
  const { slim } = useDevice();


  const joinNow = async () => {
    try {
      let t = new Task();
      setJoinTask(t);
      let data = await t.wait();
      await updateStation({ ...data, isNetworkMember: true });
      onJoined();
    } catch (err) {
      console.log(err);
    } finally {
      setJoinTask(null);
    }
  };

  return (
    <Box className={slim ? classes.rootSlim : classes.root}>
      <Stack direction="row" spacing={2}>

        {
          !slim ? (
            <Box>
              <img src="/assets/icons/white256.png" className={classes.appIcon} />
            </Box>
          ) : null
        }

        <Stack spacing={1}>

          <Stack>
            <Typography variant="h5">{t("assistNetwork:joinNow:title")}</Typography>
            <Typography variant="body1" color="textSecondary">{t("assistNetwork:joinNow:description")}</Typography>
          </Stack>

          <Box sx={{ paddingTop: 2, paddingBottom: 2 }}>
            <Grid container spacing={2} justifyContent="flex-start" alignItems="flex-start" sx={{ width: "auto" }}>

              <Benefit title={t("assistNetwork:joinNow:benefit1")} />
              <Benefit title={t("assistNetwork:joinNow:benefit2")} endLine />
              <Benefit title={t("assistNetwork:joinNow:benefit3")} />
              <Benefit title={t("assistNetwork:joinNow:benefit4")} endLine />
              <Benefit title={t("assistNetwork:joinNow:benefit5")} />
              <Benefit title={t("assistNetwork:joinNow:benefit6")} endLine />

            </Grid>
          </Box>

          <a href="https://help.getassist.app/nb/articles/12470322" target="_blank" className={classes.link}>
            <Typography variant="body1" color="textSecondary">{t("assistNetwork:joinNow:readMore")}</Typography>
          </a>

          <Stack direction={slim ? "column" : "row"} spacing={3} alignItems="center" className={classes.actions}>
            <Box sx={slim ? { width: "100%" } : undefined}>

              <Button size="large" variant="contained" color="secondary" onClick={joinNow} fullWidth={slim}>
                {t("assistNetwork:joinNow:action")}
              </Button>
            </Box>

            <Typography variant="body2" color="textSecondary">
              <InfoIcon fontSize="small" color="inherit" sx={{ marginBottom: -0.5 }} /> {t("assistNetwork:joinNow:notice")}
            </Typography>
          </Stack>

        </Stack>
      </Stack>

      {!!joinTask ? (
        <NetworkProfileDialog joinNow task={joinTask} />
      ) : null}
    </Box>
  );
}


function Benefit(props) {
  const { title, endLine } = props;

  return (
    <Grid item xs={12} lg={endLine ? 7 : 5}>
      <Typography variant="body1" color="textSecondary"> <CheckIcon sx={{ marginBottom: -0.5, marginRight: 1 }} color="secondary" /> {title}</Typography>
    </Grid>
  )
}